import { Injectable } from '@angular/core'
import { HttpService } from '@lla-platform/core/core-data-access'
import { Observable } from 'rxjs'
import { ATTENDANCE_API_URL } from './attendance-api-routes'
import { IAttendanceResponse, IEmplyeeAttendanceDetailReponse } from '../interfaces/attendance.interface'

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {
  constructor(private http: HttpService) {}

  getAttendance(weekNumber: number): Observable<IAttendanceResponse> {
    return this.http.post(ATTENDANCE_API_URL.getAttendance, { weekNumber })
  }

  resyncAttendance(weekNumber: number, locationIds: string[]): Observable<IAttendanceResponse> {
    return this.http.post(ATTENDANCE_API_URL.resyncAttendance, { weekNumber, locationIds })
  }

  employeeAttendanceDetails(
    employeeId: string,
    from: Date
  ): Observable<IEmplyeeAttendanceDetailReponse> {
    return this.http.post(ATTENDANCE_API_URL.employeeAttendanceDetails(employeeId), { from })
  }
}
